import {useState} from "react";

import {fetchRegionTree, IRegion} from "../../region/fetch_region_tree";
import {RegionType} from "../../region/types/RegionType";
import {
    ApiFieldToEstimatePriceType,
    cityWithEstimatedPriceStats,
    DEFAULT_API_FIELD_TO_ESTIMATE_PRICE,
    districtsWithEstimatedPriceStats
} from "../utils/estimated_price_utils";

type Region = {id: number; type: number};

interface IHook {
    isRegionValidating: boolean;
    validatePropertyEstimatedPriceRegion: (region: Region) => void;
}

export const usePropertyEstimatedPriceRegionValidation = (
    fetchEstimatedPriceData: (estimatedPriceQuery: Record<string, string | number>) => void,
    setApiFieldWithAvgPrice: (field: ApiFieldToEstimatePriceType) => void,
    onRegionValidationFail?: () => void
): IHook => {
    const [isRegionValidating, setIsRegionValidating] = useState<boolean>(true);

    const validatePropertyEstimatedPriceRegion = async (region: Region) => {
        if (region) {
            if (region.type === RegionType.CITY) {
                if (!!cityWithEstimatedPriceStats.get(region.id)) {
                    fetchEstimatedPriceData({region_id: region.id});

                    setIsRegionValidating(false);
                } else {
                    onRegionValidationFail?.();
                }

                return;
            }

            if (region.type > RegionType.CITY) {
                const shouldBreakRegionFetching = (region: IRegion): boolean => {
                    return region.type <= RegionType.CITY;
                };

                await fetchRegionTree(region.id, shouldBreakRegionFetching)
                    .then((regions) => {
                        let cityRegionSlug: string | null = null;
                        let cityRegionId: number | null = null;
                        let districtRegionSlug: string | null = null;

                        regions.forEach((region) => {
                            let districtId: number = region.id;
                            let cityId: number = region.id;
                            if (region.type >= RegionType.NEIGHBORHOOD) {
                                districtId = region.parents.find((parent) => parent.type === RegionType.DISTRICT)?.id ?? region.id;
                                cityId = region.parents.find((parent) => parent.type === RegionType.CITY)?.id ?? region.id;
                            }
                            if (cityWithEstimatedPriceStats.has(cityId)) {
                                cityRegionSlug = cityWithEstimatedPriceStats.get(cityId) ?? null;
                                cityRegionId = cityId;
                            }
                            if (districtsWithEstimatedPriceStats.has(districtId)) {
                                const districtRecord = districtsWithEstimatedPriceStats.get(districtId) ?? null;
                                districtRegionSlug = districtRecord?.district ?? null;
                                cityRegionSlug = districtRecord?.city ?? null;
                            }
                        });

                        if (cityRegionSlug && cityRegionId) {
                            const query: Record<string, string | number> = {region_id: cityRegionId};

                            if (districtRegionSlug) {
                                query.slug_district = districtRegionSlug;
                                query.slug_city = cityRegionSlug;

                                delete query.region_id;

                                setApiFieldWithAvgPrice(DEFAULT_API_FIELD_TO_ESTIMATE_PRICE);
                            }

                            fetchEstimatedPriceData(query);
                        } else {
                            onRegionValidationFail?.();
                        }
                    })
                    .finally(() => setIsRegionValidating(false));
            }
        }
    };

    return {
        isRegionValidating,
        validatePropertyEstimatedPriceRegion
    };
};
import {useState} from "react";

import {fetchRegionTree, IRegion} from "../../region/fetch_region_tree";
import {RegionType} from "../../region/types/RegionType";
import {
    ApiFieldToEstimatePriceType,
    cityWithEstimatedPriceStats,
    DEFAULT_API_FIELD_TO_ESTIMATE_PRICE,
    districtsWithEstimatedPriceStats
} from "../utils/estimated_price_utils";

type Region = {id: number; type: number};

interface IHook {
    isRegionValidating: boolean;
    validatePropertyEstimatedPriceRegion: (region: Region) => void;
}

export const usePropertyEstimatedPriceRegionValidation = (
    fetchEstimatedPriceData: (estimatedPriceQuery: Record<string, string | number>) => void,
    setApiFieldWithAvgPrice: (field: ApiFieldToEstimatePriceType) => void,
    onRegionValidationFail?: () => void
): IHook => {
    const [isRegionValidating, setIsRegionValidating] = useState<boolean>(true);

    const validatePropertyEstimatedPriceRegion = async (region: Region) => {
        if (region) {
            if (region.type === RegionType.CITY) {
                if (!!cityWithEstimatedPriceStats.get(region.id)) {
                    fetchEstimatedPriceData({region_id: region.id});

                    setIsRegionValidating(false);
                } else {
                    onRegionValidationFail?.();
                }

                return;
            }

            if (region.type > RegionType.CITY) {
                const shouldBreakRegionFetching = (region: IRegion): boolean => {
                    return region.type <= RegionType.CITY;
                };

                await fetchRegionTree(region.id, shouldBreakRegionFetching)
                    .then((regions) => {
                        let cityRegionSlug: string | null = null;
                        let cityRegionId: number | null = null;
                        let districtRegionSlug: string | null = null;

                        regions.forEach((region) => {
                            let districtId: number = region.id;
                            let cityId: number = region.id;
                            if (region.type >= RegionType.NEIGHBORHOOD) {
                                districtId = region.parents.find((parent) => parent.type === RegionType.DISTRICT)?.id ?? region.id;
                                cityId = region.parents.find((parent) => parent.type === RegionType.CITY)?.id ?? region.id;
                            }
                            if (cityWithEstimatedPriceStats.has(cityId)) {
                                cityRegionSlug = cityWithEstimatedPriceStats.get(cityId) ?? null;
                                cityRegionId = cityId;
                            }
                            if (districtsWithEstimatedPriceStats.has(districtId)) {
                                const districtRecord = districtsWithEstimatedPriceStats.get(districtId) ?? null;
                                districtRegionSlug = districtRecord?.district ?? null;
                                cityRegionSlug = districtRecord?.city ?? null;
                            }
                        });

                        if (cityRegionSlug && cityRegionId) {
                            const query: Record<string, string | number> = {region_id: cityRegionId};

                            if (districtRegionSlug) {
                                query.slug_district = districtRegionSlug;
                                query.slug_city = cityRegionSlug;

                                delete query.region_id;

                                setApiFieldWithAvgPrice(DEFAULT_API_FIELD_TO_ESTIMATE_PRICE);
                            }

                            fetchEstimatedPriceData(query);
                        } else {
                            onRegionValidationFail?.();
                        }
                    })
                    .finally(() => setIsRegionValidating(false));
            }
        }
    };

    return {
        isRegionValidating,
        validatePropertyEstimatedPriceRegion
    };
};
